import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";
import { save_target_weight_api } from "src/DAL/exercise/exercise";
import { _get_user_from_localStorage_new } from "src/DAL/localStorage/localStorage";
import { gr } from "src/design-system/tokens";
import GrTextField from "src/design-system/components/GrTextField";
import GrSelect from "src/design-system/components/GrSelect";
import GrButton from "src/design-system/components/GrButton";

// Units & target (inside the Weight Tracker dialog). The first time it has to be saved.

const LENGTH_UNITS = [
  { value: "cm", label: "Centimeters" },
  { value: "inch", label: "Inches" },
];

const select_array = [
  {
    name: "weight_unit",
    label: "Weight unit",
    menuOption: [
      { value: "kg", label: "Kilograms" },
      { value: "lbs", label: "Pounds" },
    ],
  },
  { name: "chest_unit", label: "Chest unit", menuOption: LENGTH_UNITS },
  { name: "waist_unit", label: "Waist unit", menuOption: LENGTH_UNITS },
  { name: "hip_unit", label: "Hip unit", menuOption: LENGTH_UNITS },
  { name: "arm_unit", label: "Arm unit", menuOption: LENGTH_UNITS },
  { name: "thigh_unit", label: "Thigh unit", menuOption: LENGTH_UNITS },
];

const gridSx = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" },
  gap: gr.space[4],
};

const AddUnits = ({ setOpenSetting, weight_list, canCancel = true }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [isFormLoading, setIsFormLoading] = useState(false);

  const [inputs, setInputs] = useState({
    target_weight: "",
    weight_unit: "kg",
    chest_unit: "cm",
    waist_unit: "cm",
    hip_unit: "cm",
    arm_unit: "cm",
    thigh_unit: "cm",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsFormLoading(true);
    let postData = {
      target_weight: inputs.target_weight,
      weight_unit: inputs.weight_unit,
      chest_unit: inputs.chest_unit,
      waist_unit: inputs.waist_unit,
      hip_unit: inputs.hip_unit,
      arm_unit: inputs.arm_unit,
      thigh_unit: inputs.thigh_unit,
    };

    const result = await save_target_weight_api(postData);
    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      localStorage.setItem(`user_data`, JSON.stringify(result?.member));
      localStorage.setItem(`user_data_new`, JSON.stringify(result?.member));
      localStorage.setItem("unit_added", true);
      setIsFormLoading(false);
      weight_list();
      setOpenSetting(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsFormLoading(false);
    }
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  useEffect(() => {
    let userInfo = _get_user_from_localStorage_new();
    setInputs((prevValue) => ({
      ...prevValue,
      target_weight: userInfo?.target_weight,
      weight_unit: userInfo?.weight_unit,
      chest_unit: userInfo?.chest_unit,
      waist_unit: userInfo?.waist_unit,
      hip_unit: userInfo?.hip_unit,
      arm_unit: userInfo?.arm_unit,
      thigh_unit: userInfo?.thigh_unit,
    }));
  }, []);

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ display: "grid", gap: gr.space[4] }}>
      <Box component="p" sx={{ m: 0 }}>
        Choose your target and the units for your weight and measurements. You can change them
        any time from Units & target.
      </Box>
      <Box sx={gridSx}>
        <GrTextField
          type="number"
          label="Target weight"
          name="target_weight"
          value={inputs.target_weight || ""}
          required
          onChange={handleChange}
          InputProps={{
            // The target is saved in kg (the API converts it for members who use lbs).
            endAdornment: <InputAdornment position="end">Kg</InputAdornment>,
          }}
        />
        {select_array.map((item) => (
          <GrSelect
            key={item.name}
            required
            label={item.label}
            name={item.name}
            value={inputs[item.name] || ""}
            onChange={handleChange}
            options={item.menuOption}
          />
        ))}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: gr.space[3] }}>
        {canCancel ? (
          <GrButton variant="quiet" onClick={() => setOpenSetting(false)}>
            Cancel
          </GrButton>
        ) : null}
        <GrButton type="submit" loading={isFormLoading}>
          Save
        </GrButton>
      </Box>
    </Box>
  );
};

export default AddUnits;
